export type StudioEnvSubDomain = 'us-sandbox' | 'sandbox' | 'us' | 'skit'

export const fieldToDisplay = (field: string, delim = '_') => {
  try {
    return field
      ?.split(delim)
      .filter((obj) => obj !== '')
      .map((obj) => `${obj[0].toUpperCase()}${obj.substr(1)}`)
      .join(' ')
  } catch (err) {
    return field
  }
}

export const stringifyObject = (object: object, ignoreKeys: string[]) => {
  let toReturn = Object.entries(object).map((row: string[]) => {
    if (!ignoreKeys.includes(row[0])) return `${row[0]}: ${row[1]}\n`
  })
  return toReturn.join('')
}

export const objectifyString = (string: string) => {
  let toReturn: any = {}
  if (!string) {
    return toReturn
  }
  for (let x of string.trim().split('\n')) {
    const [key, ...rest] = x.split(':')
    const value = rest.join(':')
    toReturn[key.trim()] = value.trim()
  }
  return toReturn
}

export const slugify = (s: string) => {
  const slug = s.trim().toLowerCase().replace(/ +/g, '-')
  return slug
}

export const getQueryParams = (query: Object = {}) => {
  let params = new URLSearchParams()
  for (let [key, value] of Object.entries(query)) {
    if (Array.isArray(value)) {
      for (let val of value) params.append(key, val)
    } else {
      params.append(key, value)
    }
  }
  return params
}

export const combineErrorMessages = (errors: any) => {
  try {
    if (Array.isArray(errors)) {
      if (errors.length === 0) {
        return errors[0]
      }
      return errors.join(' , ')
    }
    return JSON.stringify(errors)
  } catch (e) {
    console.error(e)
    return JSON.stringify(errors)
  }
}

export const IsObject = (v: any) => {
  if (typeof v === 'object' && !Array.isArray(v) && v !== null) {
    return true
  }
  return false
}

export const ModifyList = (oldList: any[], payload: any) => {
  // clone the list
  let list = [...oldList]
  if (IsObject(payload)) {
    // if the payload is an object, it's a single object, so add it to the list
    list = list.filter((l: any) => l.id !== payload.id)
    list.push(payload)
  } else if (Array.isArray(payload)) {
    // if the payload is an array, it's a list of objects, so add them to the list
    list = list.filter((l: any) => !payload.map((p: any) => p.id).includes(l.id)).concat(payload)
  } else if (Number.isInteger(payload)) {
    // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
    list = list.filter((l: any) => l.id !== payload)
  } else if (typeof payload === 'string') {
    // if the payload is an integer, it's a slug sent in delete operations, so remove it from the list
    list = list.filter((l: any) => l.slug !== payload)
  }
  return list
}
// This can change when we know the exact domain names for appications
export const isAppWebsite =
  window.location.hostname.startsWith('app.') ||
  window.location.origin === 'http://localhost:3001' ||
  window.location.hostname.startsWith('app-beta.')

/**
 * Throws an Error indicating that a method is not implemented.
 *
 * @throws {Error} Always throws an Error with the message "Method not implemented".
 * @returns {never} This function never returns as it always throws an Error.
 */
export function _notImplemented(message = ''): never {
  throw new Error(`Method not implemented ${message}`)
}

/**
Resolves a promise with the provided value after the specified delay.
@param {*} value - The value to be resolved in the promise.
@param {number} delay - The delay in milliseconds before resolving the promise.
@returns {Promise} - A promise that resolves with the provided value after the specified delay.
*/
export const resolveAfter: <T = any>(value: any, delay: number) => Promise<T> = (value, delay) =>
  new Promise((resolve) => {
    setTimeout(() => resolve(value), delay)
  })

export const capitalizeFirstLetter = (str: string) => {
  if (str.length === 0) {
    return str // Return empty string if input is empty
  }

  const firstLetter = str.charAt(0).toUpperCase()
  const restOfString = str.slice(1).toLowerCase()

  return firstLetter + restOfString
}

export const getFileNameFromContentDisposition = (contentDisposition: string) => {
  if (typeof contentDisposition !== 'string') return null
  const fileNameString = contentDisposition.split(';').find((n) => n.includes('filename='))
  if (fileNameString) {
    return fileNameString.replace('filename=', '').trim()
  }
}

export const getCurrentEnvironment = (): string => {
  // Get the current URL
  const currentURL = new URL(window.location.href)

  const envVar = currentURL.host.split('.').splice(1).join('.')

  // Return the environment based on the subdomain
  return envVar
}

export const isSkitUsDomain = (window as any)?.appConfig?.REGION == 'US'

export const isSMSAgent = (template_type) => {
  return ['SMS Agent', 'SMS Application']?.includes(template_type)
}
